import { readMarketingAttribution } from './MarketingAttribution';

export const pushMarketingEvent = ({
  storage,
  dataLayer = typeof window !== 'undefined' ? (window.dataLayer = window.dataLayer || []) : null,
  product = 'ap_central',
  ...eventProperties
} = {}) => {
  if (!dataLayer || !eventProperties.event) return null;

  const attribution = readMarketingAttribution(storage);
  const payload = {
    ...eventProperties,
    product,
    has_marketing_attribution: Boolean(attribution),
  };
  if (attribution) {
    const params = attribution.params || {};
    payload.marketing_session_id = params.am_session_id || undefined;
    payload.marketing_visitor_id = params.am_visitor_id || undefined;
    payload.handoff_key = params.am_handoff || undefined;
    payload.utm_source = params.utm_source || undefined;
    payload.utm_medium = params.utm_medium || undefined;
    payload.utm_campaign = params.utm_campaign || undefined;
  }

  Object.keys(payload).forEach(key => {
    if (payload[key] === undefined || payload[key] === '') delete payload[key];
  });
  dataLayer.push(payload);
  return payload;
};

export const firebaseAuthMethod = firebaseUser => {
  const providerId = firebaseUser?.providerData?.[0]?.providerId || '';
  if (providerId.includes('google')) return 'google';
  if (providerId.includes('apple')) return 'apple';
  if (providerId.includes('password')) return 'email';
  return providerId || 'firebase';
};
